import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PagesContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  margin: '2rem 0',
}));

export const LoadingBox = styled(Box)(() => ({
  width: '100%',
  marginTop: 16,
}));

export const SelectedMonthIndicator = styled(Box)(({ theme }) => ({
  background: theme.palette.secondary.main,
  color: theme.palette.common.white,
  textTransform: 'capitalize',
  textAlign: 'center',
  padding: 16,
  borderTopLeftRadius: 12,
  borderTopRightRadius: 12,
  fontWeight: 600,
  fontSize: 21,
}));

export const PendingOnlyIndicator = styled(Box)(() => ({
  background: '#FAEEDA',
  color: '#633806',
  marginBottom: 24,
  padding: '12px 24px',
  borderRadius: 12,
}));
